"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonWrapperSpan = exports.ButtonWrapper = exports.Label = exports.TooltipWrapper = exports.TooltipSomething = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../../../../theme/colors");
exports.TooltipSomething = styled_components_1.default.div `
  display: ${({ $show }) => ($show ? `flex` : `none`)};
  align-items: center;
  background-color: ${colors_1.BLACK};
  padding: 7px 8px 5px 8px;
  flex-wrap: wrap;
  width: ${({ $isFitContent }) => ($isFitContent ? "fit-content" : "117px")};
  position: absolute;
  z-index: 5;
  top: 100%;
  right: -55px;
  border-radius: ${({ $edges }) => ($edges === "rounded" ? `4px` : `0`)};

  ${({ $inlineTranslation }) => $inlineTranslation &&
    (0, styled_components_1.css) `
      width: 220px;
      right: -105px;
    `}
  ${({ $position }) => $position === "bottom" &&
    (0, styled_components_1.css) `
      bottom: -112px;
      top: auto;
      right: -41px;
    `}
`;
exports.TooltipWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
`;
exports.Label = styled_components_1.default.label `
  font-family: SwegonBrown;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  display: flex;
  flex-wrap: wrap;
  color: ${colors_1.WHITE};
  text-align: ${({ $isTextCentered }) => ($isTextCentered ? "center" : "none")};

  ${({ $inlineTranslation }) => $inlineTranslation &&
    (0, styled_components_1.css) `
      label,
      input {
        color: ${colors_1.WHITE};
      }

      input[type="text"] {
        min-width: 180px;
        font-size: 13px;
      }
    `}
`;
exports.ButtonWrapper = styled_components_1.default.div `
  position: relative;
  cursor: pointer;
`;
exports.ButtonWrapperSpan = styled_components_1.default.span `
  margin-left: 4px;
  display: flex;
  align-items: center;
`;
//# sourceMappingURL=Tooltip.styles.js.map